"use client";

import { ComponentPropsWithoutRef, FC, ReactElement, useState } from "react";
import PresentationCard from "../PresentationCard";
import Typography from "../Typography";
import { MediaBlockData } from "./MediaBlock";

export type HowToBlockData = {
  title: string;
  items: {
    title: string;
    description: string;
    media: MediaBlockData;
    icon?: ReactElement;
  }[];
};

type HowToBlockProps = {
  data: HowToBlockData;
} & ComponentPropsWithoutRef<"section">;

const HowToBlock: FC<HowToBlockProps> = ({ data, ...rest }) => {
  const [playingVideoIndex, setPlayingVideoIndex] = useState<number | null>(
    null
  );

  return (
    <section
      {...rest}
      className={`${rest.className} mx-auto text-center my-32 md:my-64 px-3`}
    >
      <Typography variant="h2" component="h2" className="max-w-3xl mx-auto">
        {data.title}
      </Typography>
      <div className="flex flex-col md:flex-row gap-12 mt-16">
        {data.items.map((item, index) => (
          <PresentationCard
            key={item.title}
            title={item.title}
            description={item.description}
            media={item.media}
            index={index}
            playingVideoIndex={playingVideoIndex}
            setPlayingVideoIndex={setPlayingVideoIndex}
          />
        ))}
      </div>
    </section>
  );
};

export default HowToBlock;
